import { getGlobalObject } from './get-global-object';

function getSiteHost() {
  const globalObj = getGlobalObject();
  if (globalObj?.commonConfig) {
    return globalObj.commonConfig.host || 'EDITOR';
  }

  return 'EDITOR';
}

export function isHostStudio() {
  return getSiteHost() === 'STUDIO';
}

export function isHostEditor3() {
  return getSiteHost() === 'EDITOR3';
}

export function isHostStudio2() {
  return getSiteHost() === 'STUDIO2';
}

export function isHostClassicEditor() {
  return getSiteHost() === 'EDITOR';
}

export function isBuilderEditor() {
  return isHostEditor3() || isHostStudio2();
}
